import type { MediaCandidates } from 'js/src/client';
import type { DeepReadonly } from 'js/src/libs/consts';
import type { RootState } from 'js/src/libs/RootState';

export function getSourceSegmentForScene(
    state: RootState,
    sceneId: string | null,
): string | undefined {
    if (!sceneId) return undefined;
    return state.recommendations.source_segment_per_rephrased_scene[sceneId];
}

export function getDatasetMetadata(state: RootState) {
    return state.recommendations.dataset_metadata;
}

export function getRecommendedVideoResponseMediaCandidates(
    state: RootState,
): DeepReadonly<MediaCandidates> | null {
    return state.recommendations?.recommendedVideoResponse?.media_candidates ?? null;
}

/**
 * Extracts MediaCandidates from Redux state for agent use.
 * Returns null if no media candidates are available.
 */
export function getMediaCandidatesForAgent(state: RootState): DeepReadonly<MediaCandidates> | null {
    return getRecommendedVideoResponseMediaCandidates(state);
}
